export default "__VITE_ASSET__23b799f6__"